import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import authService from '../../services/auth';
// Import test authentication functions


/**
 * Login component for user authentication
 */
const Login = () => {
  // Initialize credential state with empty values
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  // Check if user is already logged in
  useEffect(() => {
    console.log('Login component mounted, checking auth status');
    const isLoggedIn = authService.isLoggedIn();
    console.log('Auth status in Login component:', isLoggedIn);
    if (isLoggedIn) {
      console.log('User is logged in, redirecting to dashboard');
      navigate('/dashboard');
    }
  }, [navigate]);

  /**
   * Handle form submission
   * @param {Event} e - Form submission event
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    console.log('Login form submitted');

    try {
      console.log('Attempting to login with authService');
      await authService.login(username, password);
      console.log('Login successful');
      navigate('/dashboard');
    } catch (err) {
      console.error('Login failed');
      setError(err.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-800 rounded-lg shadow-lg p-8 w-full max-w-md">
      {error && (
        <div className="rounded-md bg-red-900 p-4 mb-6" role="alert" aria-live="assertive">
          <div className="flex">
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-200">Error</h3>
              <div className="mt-2 text-sm text-red-100">
                <p>{error}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      
      <div className="text-center mb-6">
        <h2 className="text-2xl font-bold text-white">Welcome Back</h2>
        <p className="mt-2 text-sm text-gray-400">Sign in to your account</p>
      </div>
      
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="username" className="sr-only">Username</label>
          <input
            id="username"
            name="username"
            type="text"
            required
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            className="block w-full rounded-md border border-gray-600 bg-gray-700 px-3 py-2 placeholder-gray-400 text-white shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </div>
        
        <div>
          <label htmlFor="password" className="sr-only">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            required
            autoComplete="current-password"
            className="block w-full rounded-md border border-gray-600 bg-gray-700 px-3 py-2 placeholder-gray-400 text-white shadow-sm focus:border-blue-500 focus:outline-none focus:ring-blue-500 sm:text-sm"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        
        <div>
          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-md bg-blue-600 py-2 px-4 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:bg-blue-300"
          >
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </div>
      </form>
      
      <div className="mt-6 text-center text-sm">
        <p className="text-gray-400">
          Don't have an account? <Link to="/register" className="font-medium text-blue-400 hover:text-blue-300">Register here</Link>
        </p>
        <p className="mt-2">
          <Link to="/forgot-password" className="font-medium text-blue-400 hover:text-blue-300">Forgot your password?</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
